import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
// import { useTranslation } from "react-i18next";
import HeaderTitle from "../../../../components/header/headerTitle/headerTitle";
// import { asset } from "../../../../helpers/dom.helper";
import { ALL_ITEM_ECOMERCE_ASISTANT } from "./itemJson";
import ItemList from "../../itemListContainer/itemList";

function EcommerceAssistantPage(props) {
  const [selectedItem, setSelectedItem] = useState([]);

  useEffect(() => {
    const jewelsParam = props.match.params.jewels;
    const filtered = ALL_ITEM_ECOMERCE_ASISTANT[0].itemList.filter(item => item.itemSelected === jewelsParam);
    setSelectedItem(filtered)
  }, [props.match.params.jewels]); 


  return (
    <>
      <Helmet>
        <title>Custom Luxury E-Commerce Packaging Solutions | Lussopack</title>
        <meta name="description" content="Lussopack provides luxury packaging solutions to help online businesses transfer products safely, ensuring an ultimate unboxing experience." />
        <meta name="keywords" content="e commerce packaging solutions"/>
        <meta name="robots" content="noindex" />
        <link rel="canonical" href="https://lussopack.com/packaging/e-commerce-assistant/" />
      </Helmet>

      <HeaderTitle
        {...props}
        textHeader={"E-Commerce Assistant"}
      />        
      <ItemList 
        selectedItem={selectedItem}
      />
    </>
  );
}

export default EcommerceAssistantPage;
